/* global SuperAppJsChannel */
import axios from "axios";
import cookieService from "../services/cookieService";
import AppConstants from "../constants/AppConstants";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = false;

axios.interceptors.request.use(
  (config) => {
    const token = cookieService.get(AppConstants.CS_KEY.ACCESS_TOKEN);

    if (token && !config.url.includes("/auth/refresh-token")) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        },
      };
    }

    return {
      ...config,
      headers: {
        ...config.headers,
      },
    };
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
};

const cookieConfig = {
  ...AppConstants.COOKIE_CONFIG,
  expires: 30 / 60 / 60 / 24,
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest.retry) {
      if (!originalRequest.url.includes("/auth/sign-out")) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }
        originalRequest.retry = true;
        isRefreshing = true;

        const refreshToken = cookieService.get(
          AppConstants.CS_KEY.REFRESH_TOKEN
        );

        return new Promise((resolve, reject) => {
          axios
            .post(
              `${process.env.REACT_APP_API_SSO_URL}/auth/refresh-token`,
              { refresh_token: refreshToken }
            )
            .then(({ data }) => {
              const newAccessToken = data?.data?.token;
              const newRefreshToken = data?.data?.refresh_token;

              cookieService.set(
                AppConstants.CS_KEY.ACCESS_TOKEN,
                newAccessToken,
                cookieConfig
              );
              cookieService.set(
                AppConstants.CS_KEY.REFRESH_TOKEN,
                newRefreshToken,
                cookieConfig
              );

              axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
              originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

              if (typeof SuperAppJsChannel !== "undefined") {
                SuperAppJsChannel.postMessage(
                  JSON.stringify({
                    type: "accessTokenUpdated",
                    data: {
                      access_token: newAccessToken,
                      refresh_token: newRefreshToken,
                    },
                  })
                );
              }

              processQueue(null, newAccessToken);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);

              if (err.response?.status === 422) {
                cookieService.remove(AppConstants.CS_KEY.ACCESS_TOKEN, cookieConfig);
                cookieService.remove(AppConstants.CS_KEY.REFRESH_TOKEN, cookieConfig);
                cookieService.set(AppConstants.SS_KEY.LOGIN_FIRST_MESSAGE, "1", cookieConfig);
                cookieService.remove(AppConstants.CS_KEY.RETURN_URL_AFTER_LOGIN, cookieConfig);
                window.location.href = "/login";
              }

              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }
    }

    return Promise.reject(error);
  }
);
